var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import _ from "lodash";
import { FormSection } from "@ane/ui-components/lib/components/FormSection";
import { ResizeGroupAs } from "./ResizeGroupAs.js";
import { Accordion } from "@ane/ui-components";
const SubClusterListV2 = ({
  isReadOnly,
  subClusterList,
  onRenderSubCluster,
  onAddSubCluster,
  onDeleteSubCluster
}) => {
  return /* @__PURE__ */ jsx(
    FormSection,
    {
      heading: "Sub-clusters",
      onRenderHeader: (props, defaultRender) => /* @__PURE__ */ jsx(
        ResizeGroupAs,
        {
          ariaLabelForGroup: "Sub-clusters",
          data: [
            {
              key: "addRow",
              ariaLabel: "Add sub-cluster",
              text: "Add sub-cluster",
              disabled: !!isReadOnly,
              iconProps: {
                iconName: "Add"
              },
              onClick: onAddSubCluster
            }
          ],
          onRenderData: ({ primaryItems, overflowItems }, onRenderItem, onRenderOverflowButton) => defaultRender(__spreadProps(__spreadValues({}, props), {
            overflowSetProps: {
              items: primaryItems,
              overflowItems,
              onRenderItem,
              onRenderOverflowButton
            }
          }))
        }
      ),
      children: _.map(subClusterList, (item, index) => {
        const groupName = "Sub-cluster " + (index + 1);
        return /* @__PURE__ */ jsx(
          Accordion,
          {
            ariaLabel: groupName,
            header: groupName,
            showContentOnRender: !item.collapsed,
            onRenderHeader: (props, defaultRender) => /* @__PURE__ */ jsx(
              ResizeGroupAs,
              {
                ariaLabelForGroup: groupName,
                data: [
                  {
                    key: "deleteRow",
                    ariaLabel: "Delete",
                    text: "Delete",
                    disabled: !!isReadOnly,
                    iconProps: {
                      iconName: "Delete"
                    },
                    onClick: () => onDeleteSubCluster(index)
                  }
                ],
                onRenderData: ({ primaryItems, overflowItems }, onRenderItem, onRenderOverflowButton) => defaultRender(__spreadProps(__spreadValues({}, props), {
                  overflowSetProps: {
                    items: primaryItems,
                    overflowItems,
                    onRenderItem,
                    onRenderOverflowButton
                  }
                }))
              }
            ),
            children: onRenderSubCluster({ itemIndex: index })
          }
        );
      })
    }
  );
};
export {
  SubClusterListV2
};
//# sourceMappingURL=SubClusterListV2.js.map
